angular
    .module('app')
    .component('recycleBin', {
        templateUrl: '/templates/pages/recycle-bin/recycle-bin.html',
        controller: 'RecycleBinController',
        controllerAs: 'vm',
    });